import { scaleW } from '@/common/style';
import { StyleSheet } from 'react-native';
export const styles = StyleSheet.create({
    img: {
        width: scaleW(100),
        height: scaleW(100),
    },
    imageBox: {
        width: scaleW(100),
        height: scaleW(100),
        marginRight: 10,
        borderRadius: 6,
        overflow: 'hidden',
    },
    imgErr: {
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
    },
    textRed: {
        color: '#FF4906',
    },
    textBlack: {
        color: '#000',
    },
    price: {
        fontSize: 16,
        marginRight: 4,
        fontWeight: 'bold',
    },
    underlinePrice: {
        textDecorationLine: 'line-through',
        fontSize: 11,
        color: 'rgba(153, 153, 153, 1)',
    },
    decreasePrice: {
        fontSize: 12,
        marginTop: 6,
    },
    timeoutStr: {
        color: '#FF4906',
        marginTop: 8,
        fontSize: 12,
        lineHeight: 16,
    },
});
